module.exports = __webpack_public_path__ + "img/capa2.23e76880.webp";